// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__Api from "../../../core/Api.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_landing__Video from "./Video.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactHelmetAsync from "react-helmet-async";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function Jumbo(Props) {
  let setBodyFixed = Props.setBodyFixed;
  const intl = ReactIntl.useIntl();
  const match = React.useState(function () {
    return false;
  });
  const setPlayVideo = match[1];
  const playVideo = match[0];
  const language = Buhta_landing__Route.getLanguage(undefined);
  const languageStr = Buhta_models__Locale.toString(language);
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  React.useEffect((function () {
    Curry._1(setBodyFixed, (function (param) {
      return playVideo;
    }));
  }), []);
  const match$1 = Buhta_landing__Content.Context.useContent(undefined);
  const dispatchContent = match$1[1];
  const homePage = match$1[0].homePage;
  React.useEffect((function () {
    const __x = $$Promise.all({
      hd: Buhta_landing__Api.homePage(languageStr),
      tl: /* [] */ 0
    });
    $$Promise.get(__x, (function (respList) {
      Stdlib__List.iter((function (res) {
        Buhta_landing__Api.handleResponse(res, dispatchContent, undefined);
      }), respList);
    }));
  }), [languageStr]);
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(ReactHelmetAsync.Helmet, {
        children: JsxRuntime.jsx("script", {
          src: "https://www.youtube.com/iframe_api"
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h1", {
            children: homePage.title,
            className: "h3 lg:h1 text-center flex m-auto text-white px-11.25 lg:px-0 max-w-175"
          }),
          JsxRuntime.jsx("h2", {
            children: homePage.subtitle,
            className: "paragraph-large lg:h5 text-center text-white mt-4 lg:mt-6 px-6"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
                label: Buhta_landing__I18n.trans(intl, "start_using"),
                onClick: (function (param) {
                  Buhta_landing__EventHandlers.scrollToFooter(deviceType);
                })
              }),
              JsxRuntime.jsxs("button", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "mr-2",
                    src: StaticAsset.src("/static/icons/play.svg")
                  }),
                  Buhta_landing__I18n.trans(intl, "watch_video")
                ],
                className: "h6 text-white flex sm:ml-8 mt-6 sm:mt-0",
                onClick: (function (param) {
                  Curry._1(setPlayVideo, (function (param) {
                    return true;
                  }));
                })
              })
            ],
            className: "mt-8 lg:mt-16 flex-col sm:flex-row flex justify-center items-center"
          })
        ],
        className: "bg-jumbo bg-cover bg-center lg:h-207 pt-30 lg:pt-60 pb-30 lg:pb-0"
      }),
      playVideo ? JsxRuntime.jsx(Buhta_landing__Video.make, {
          closeVideo: (function (param) {
            Curry._1(setPlayVideo, (function (param) {
              return false;
            }));
          })
        }) : null
    ]
  });
}

const make = Jumbo;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
